module.exports = __webpack_public_path__ + "img/lowerabs-mesomorph-male.56089134.svg";